/**
 * @file 通用请求头设置
 * @author sunyingying01
 */

import Cookies from 'js-cookie';
import {v4 as uuidv4} from 'uuid';
import {type BeforeRequestHook} from 'ky';

export const commonHeaderHook: BeforeRequestHook = request => {
    const csrfToken = Cookies.get('bce-user-info') ?? '';
    if (import.meta.env.VITE_IS_LOGIN) {
        Cookies.set('fm_login_userid', import.meta.env.VITE_USERID);
        Cookies.set('fm_login_session', import.meta.env.VITE_SESSION);
    }
    // 到时候注释 测试用
    request.headers.set('x-user-id', uuidv4());
    request.headers.set('x-bce-request-id', uuidv4());
    request.headers.set('csrfToken', csrfToken);
};
